<template>
    <div class="search" :style="{ width: searchWidth + 'px' }">
        <div class="search-content">
            <img src="../assets/iconFolder/common/common_search_icon.png" alt="#">
            <input v-model="searchWords" type="text" :placeholder="placeholder" @keydown.enter="searchAction">
        </div>
        <div class="operation">
            <!-- 清除按钮 -->
            <button @click="clearAction" class="clear" v-show="searchWords.length > 0"><img src="../assets/iconFolder/common/common_close_icon.png" alt="#"></button>
            <!-- 分隔线 -->
            <div class="seperate"></div>
            <!-- 搜索按钮 -->
            <button @click="searchAction" class="search-btn">搜索</button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        searchWidth: {
            type: Number,
            default: 388
        },
        placeholder: String
    },
    data() {
        return {
            searchWords: ''
        }
    },
    methods: {
        // 清除
        clearAction() {
            this.searchWords = ''
            this.searchAction()
        },
        searchAction() {
            // this.$parent.searchAction(this.searchWords)
            this.$emit('searchAction', this.searchWords)
        }
    },
}
</script>
<style scoped>
    .search {
        width: 380px;
        height: 40px;
        background: #f4f4f4;
        border-radius: 6px;
        display: flex;
        align-items: center;
        margin-right: 16px;
        justify-content: space-between;
    }
    .search .search-content {
        height: 100%;
        width: calc(100% - 106px);
        display: flex;
        align-items: center;
    }
    .search-content img {
        width: 18px;
        height: 18px;
        margin: 11px 12px 11px 20px;
    }
    .search-content input {
        border: none;
        background: none;
        height: 40px;
        width: calc(100% - 50px);
        font-size: 16px;
        color: #131313;
        /* background-color: #ff0; */
    }
    .search-content input:focus {
        outline: none;
    }
    .search .operation {
        display: flex;
        align-items: center;
    }
    .search .operation .seperate {
        /* background-color: rgb(160, 196, 223); */
        background-color: #0054a0;
        opacity: 0.15;
        width: 2px;
        height: 16px;
        margin: 0 8px;
    }
    .search .operation button {
        background: none;
        box-shadow: none;
        border: none;
    }
    .search .operation .clear img {
        width: 20px;
        height: 20px;
    }
    .search .operation .search-btn {
        font-size: 16px;
        font-weight: 400;
        color: #181818;
        margin-right: 12px;
    }
</style>